import React from 'react';

const UserIcon = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={22} height={22} {...props}>
      <defs>
        <style>{'.prefix__b{fill:none}.prefix__c{fill:#fff}'}</style>
      </defs>
      <g stroke='#f5f5f5' fill='none'>
        <circle cx={11} cy={11} r={11} stroke='none' />
        <circle className='prefix__b' cx={11} cy={11} r={10.5} />
      </g>
      <path className='prefix__b' d='M0 0h22v22H0z' />
      <path
        className='prefix__c'
        d='M11 4.5a3.13 3.13 0 103.13 3.13A3.134 3.134 0 0011 4.5zM14.895 12.806a4.463 4.463 0 00-3.2-1.349h-1.39a4.463 4.463 0 00-3.2 1.349 4.562 4.562 0 00-1.322 3.219.348.348 0 00.348.348h9.739a.348.348 0 00.348-.348 4.562 4.562 0 00-1.323-3.219z'
      />
    </svg>
  );
};

export default UserIcon;
